import { AbstractControl, ValidatorFn } from '@angular/forms';

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isWhitespace: boolean = (control.value || '')?.toString()?.trim()?.length === 0;
    return isWhitespace ? { 'whitespace': true } : null;
  };
}